export default function truncateLink(link) {
	var separator = '...'
	var strLen = 50

	if (link.length && link.length <= strLen) return link

	var sepLen = separator.length,
		charsToShow = strLen - sepLen,
		frontChars = Math.ceil(charsToShow / 2),
		backChars = Math.floor(charsToShow / 2)

	return link.substr(0, frontChars) + separator + link.substr(link.length - backChars)
}
